// =============================================================================
// FILE: packages/renderer/src/stores/ingest.store.ts
// PURPOSE: Quick Ingest dialog open state — shared so the launcher
//          and the global keyboard shortcut can drive it without a
//          parent ref.
// =============================================================================

import { useSyncExternalStore } from 'react';

interface IngestState { open: boolean }

const subs = new Set<() => void>();
let state: IngestState = { open: false };
function notify(): void { for (const s of subs) s(); }

export const ingestStore = {
  getState: (): IngestState => state,
  open():    void { state = { open: true  }; notify(); },
  close():   void { state = { open: false }; notify(); },
  toggle():  void { state = { open: !state.open }; notify(); },
  subscribe(fn: () => void): () => void { subs.add(fn); return () => subs.delete(fn); },
};

export function useIngestStore(): IngestState {
  return useSyncExternalStore(ingestStore.subscribe, ingestStore.getState, ingestStore.getState);
}
